module.exports = __webpack_public_path__ + "img/machinelearning.a84f32f8.svg";